export default __webpack_public_path__ + "assets/images/topaasia.948f4288ca1282f504009f704138e5c5.png";